export const LOGIN_SUBMIT = "LOGIN_SUBMIT";
export const SET_LOGIN_TOKEN = "SET_LOGIN_TOKEN";
export const SET_IMPERSONATE_DATA = "SET_IMPERSONATE_DATA";
export const SET_NEWLOGIN_DATA = "SET_NEWLOGIN_DATA";
export const SET_ADMINLOGIN_DATA = "SET_ADMINLOGIN_DATA";
export const RESET_STATE = "RESET_STATE";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_CURRENCY_SIGN = "SET_CURRENCY_SIGN";
export const SET_WHITE_LABELING_DATA = "SET_WHITE_LABELING_DATA";
